import axios from 'axios';
import Config from './Config';

export async function getDeliveryCostQuote(cartItems, user) {
    const dropPincode = String(user?.PostalCode || '').trim();
    const dropState = String(user?.StateName || '').trim();
    if (!/^\d{6}$/.test(dropPincode)) throw new Error('Add a valid shipping PIN code in your profile to calculate delivery.');
    const items = cartItems.map(item => ({ productId: Number(item.ProductId), quantity: Number(item.Quantity) }));
    if (!items.length || items.some(item => !Number.isInteger(item.productId) || item.productId <= 0 || !Number.isInteger(item.quantity) || item.quantity <= 0)) {
        throw new Error('Your cart contains an invalid product or quantity. Please refresh your cart.');
    }
    try {
        const response = await axios.post(`${Config.ADMIN_BASE_URL.replace(/\/$/, '')}/api/v1/delivery-cost/quote`,
            { dropPincode, ...(dropState ? { dropState } : {}), items },
            { headers: { 'Content-Type': 'application/json' } });
        const quote = response.data;
        const cost = Number(quote?.totalDeliveryCost);
        if (quote?.currency !== 'INR' || !Number.isFinite(cost) || cost < 0) throw new Error('The delivery quote was invalid. Please try again.');
        return { ...quote, totalDeliveryCost: cost };
    } catch (error) {
        if (!error.response) throw error;
        const message = error.response.data?.message || error.response.data?.error || error.response.data?.title;
        throw new Error(typeof message === 'string' && message.trim() ? message : 'Delivery cost is unavailable for this address. Please try again or update your shipping address.');
    }
}
